<template>
    <div class="TQ_inline" :style="{'width' : width, 'maxWidth' : maxWidth}">
        <on-top-container>
            <div :style="{'padding' : padding}" slot="body">

                <div v-if="file.fi_m_isImage_fb()">
                    <tq-img-fill-blur v-if="p_fillBlurImg_b" :p_att_s="file.fi_fileName_s" :p_height_s="pp_blurImgHeight_s" :pp_img-url_s="file.fi_url_s"/>
                    <tq-image v-else  class="TQ_fullScreen" :pb_src_r="file.fi_url_s"    />
                </div>

                <video v-if="file.fi_m_isVideo_fb()"
                       :style="{height: p_videoHeight_s}"
                       class="TQ_fullScreen TQ_border TQ_borderRadius TQ_box_shadow"
                       controls :src="file.fi_url_s + '#t=0.0001'" ></video>

                <audio class="TQ_fullScreen" controls :src="file.fi_url_s" v-if="file.fi_m_isAudio_fb()"></audio>
            </div>

            <div  slot="bottom">

                <on-top-container v-if="file.fi_uploadStatus_n != 1" class="TQ_fullScreen">
                    <div class="myProgress TQ_direction_ltr TQ_box_shadow TQ_fullScreen" slot="body">
                        <div class="myBar TQ_verticalAlignMiddle" :style="{'width' : format_percentage(file.fi_uploadStatus_n)}"></div>
                    </div>
                    <div class="text" slot="middle">
                        {{format_percentage(file.fi_uploadStatus_n)}}
                    </div>
                </on-top-container>
            </div>

        </on-top-container>
    </div>
</template>

<script>
    import {FB_File} from "../../../functions/src/shareCode/Share_S_Classes";
    import {format_percentage} from "../../../functions/src/shareCode/Share_S_Format";
    import OnTopContainer from "../basic/TqOnTopContainer";
    import TqImgFillBlur from "../basic2/TqImgFillBlur";
    import TqImage from "@/components/basic/TqImage";

    export default {
        name: "TqDisplayFile",
        components: {TqImage, TqImgFillBlur, OnTopContainer},
        props:{
            file : {
                require: true,
                type : FB_File
            },
            width:{
                type: String,
                default: '100%'
            },
            p_videoHeight_s:{
                type:String,
                default : "200px"
            },
            padding: {
                type: String
            },
            maxWidth:{
                type: String
            },
            p_fillBlurImg_b:{
                type:Boolean,
                default: false
            },
            pp_blurImgHeight_s:{},

        },
        data(){
            return {
                format_percentage : format_percentage,
            }
        },

    }


</script>

<style scoped lang="scss">

    .myProgress {
        width: 100%;
        background-color: #ddd;
    }
    .myBar {
        line-height: 30px;
        height: 30px;
        text-align: center;
        background-color: #4CAF50;
        color: white;
    }
</style>